import Helpers from '../helpers';

const defaultParams = {
  debug: false,
  delivery_platform: 'Terminal',
  language: 'en',
  company_uuid: 'b99752b3-443c-4c80-b559-945a95c4b805', // Prva firma
  env: 'staging',
};

export default {
  debug: !!Helpers.getUrlParam('debug') || defaultParams.debug,
  delivery_platform: Helpers.getUrlParam('delivery_platform') || defaultParams.delivery_platform,
  language: Helpers.getUrlParam('lang') || defaultParams.language,
  company_uuid: Helpers.getUrlParam('company') || defaultParams.company_uuid,
  env: Helpers.getUrlParam('env') || defaultParams.env,
};
